import { useTranslation } from "react-i18next";

const useLocale = () => {
    const [, i18n] = useTranslation();
    const locale = i18n.language;

    const setLocale = (newLocale: string) => {
        if (locale !== newLocale) {
            i18n.changeLanguage(newLocale);
        }
    };

    return [locale, setLocale] as const;
};

export default useLocale;
